<template>
    <transition name="fade" appear>
        <div class="modal-underlay" @mousedown.stop="close">
            <div class="modal" :class="finalModalClass" @mousedown.stop>
                <button
                    v-if="!unclosable"
                    type="button"
                    class="modal__close"
                    :class="closeModalClass"
                    @click="close"
                />
                <div v-if="title || $slots['head']" class="modal__head">
                    <div v-if="title" class="modal__title">{{ title }}</div>
                    <slot name="head" />
                </div>
                <div class="modal__inner">
                    <div v-if="$slots.content || $slots.default" class="modal__content">
                        <slot :close="close" />
                        <slot name="content" :close="close" />
                    </div>
                    <div v-if="$slots['bottom']" class="modal__bottom">
                        <slot name="bottom" :close="close" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        title: {
            type: String,
            default: ''
        },
        modalClass: {
            type: String,
            default: ''
        },
        noHead: {
            type: Boolean,
            default: false
        },
        unclosable: {
            type: Boolean,
            default: false
        },
        noMaxWidth: {
            type: Boolean,
            default: false
        },
        showOverflowX: {
            type: Boolean,
            default: false
        },
        fullscreen: {
            type: Boolean,
            default: false
        },
        direction: {
            type: String,
            default: 'ltr'
        }
    },
    computed: {
        finalModalClass() {
            const classes = [this.modalClass];

            if (this.noMaxWidth) {
                classes.push('modal--no-max-width');
            }

            if (this.showOverflowX) {
                classes.push('modal--show-overflow-x');
            }

            if (this.fullscreen) {
                classes.push('modal--fullscreen');
            }

            if (this.direction === 'rtl') {
                classes.push('modal--rtl');
            }

            return classes.join(' ');
        },
        closeModalClass() {
            return `modal__close__${this.direction}`;
        }
    },
    beforeMount() {
        document.body.style.overflow = 'hidden';
        // document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keyup', this.closeOnEsc);
    },
    beforeUnmount() {
        document.body.style.overflow = '';
        // document.documentElement.style.overflow = '';
        document.removeEventListener('keyup', this.closeOnEsc);
    },
    methods: {
        close() {
            if (this.unclosable) return;
            this.$emit('closed');
            this.$emit('close');
        },
        closeOnEsc(event) {
            if (event.keyCode === 27) {
                this.close();
            }
        }
    }
};
</script>

<style lang="scss" src="./Modal.scss"></style>
